import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from 'date-fns'
import * as React from 'react'
import { useBookingFormStore } from '../../providers/BookingFormStoreProvider'
import { CalendarModeEnum, IDate, IDateCheckout, ITravelDate } from '../../store/data'
import { getWeeks, useCalendarControls, useLocale } from './helpers'

type CalendarDaysProps = {
  activeDate: Date
  checkouts: IDateCheckout[]
  data: IDate[]
  isFetching: boolean
  mode: CalendarModeEnum
  onSelectDate: (date: Date) => void
  travelDate: ITravelDate
}

const CalendarDays: React.FunctionComponent<CalendarDaysProps> = ({
  activeDate,
  checkouts = [],
  data = [],
  isFetching = false,
  mode,
  onSelectDate,
  travelDate,
}) => {
  const locale = useLocale()
  const currency = useBookingFormStore((state) => state.currency)
  const { onClickAway } = useCalendarControls()
  const startOfTheSelectedMonth = startOfMonth(activeDate)
  const endOfTheSelectedMonth = endOfMonth(activeDate)
  const startDate = startOfWeek(startOfTheSelectedMonth, { locale })
  const endDate = endOfWeek(endOfTheSelectedMonth, { locale })

  return (
    <div className="weekContainer">
      {getWeeks(
        startDate,
        endDate,
        data,
        checkouts,
        mode,
        travelDate,
        activeDate,
        onSelectDate,
        onClickAway,
        isFetching,
        currency
      )}
    </div>
  )
}

export default CalendarDays
